<template>
    <div>
        <NavigationBar></NavigationBar>
        <DocumentMenu></DocumentMenu>
        <DocumentFilter></DocumentFilter>
        <DocumentList></DocumentList>
        <DocumentLink></DocumentLink>
        <DocumentDelete></DocumentDelete>
        <DocumentVisitors></DocumentVisitors>
        <DocumentNonVisitors></DocumentNonVisitors>
        <FooterView></FooterView>
    </div>
</template>
<script>
import DocumentMenu from '@/components/DocumentRepository/Document-menu.vue'
import NavigationBar from '@/components/shared/Navigation-bar.vue';
import DocumentList from '@/components/DocumentRepository/Document-list.vue'
import DocumentLink from '@/components/DocumentRepository/Document-link.vue'
import DocumentDelete from '@/components/DocumentRepository/Document-delete.vue'
import DocumentVisitors from '@/components/DocumentRepository/Document-visitors.vue'
import DocumentNonVisitors from '@/components/DocumentRepository/Document-non-visitors.vue'
import DocumentFilter from '@/components/DocumentRepository/Document-filter.vue'
import FooterView from '@/components/shared/Footer/Footer-view.vue';

export default {
    name:'DocumentRepositoryViews',

    components:{
        NavigationBar,
        DocumentMenu,
        DocumentList,
        DocumentLink,
        DocumentDelete,
        DocumentVisitors,
        DocumentNonVisitors,
        DocumentFilter,
        FooterView
    }
    
}
</script>
<style>
    
</style>